import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  templateInvite: {
    height: '100%',

    '& .contentArea': {
      display: 'flex',
      flexDirection: 'column',

      '&:not(:last-child)': {
        marginBottom: '12px',
      },
    },
  },

  invitation: {
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'row',

    '& > label': {
      width: '100%',
      color: 'var(--text-primary)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '18px',
      lineHeight: '27px',
      margin: '0 0 20px 0',
    },

    '& .viboIcon': {
      margin: '0 8px 0 0',
    },
  },
}));

export default useStyles;
